import { render, staticRenderFns } from "./SiatRiepilogoPraticheListComponent.vue?vue&type=template&id=166ce465&scoped=true"
import script from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheListComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheListComponent.vue?vue&type=style&index=0&id=166ce465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ce465",
  null
  
)

export default component.exports